(ns ui.components.expansion-panel.view
  (:require 
   [ui.util :as uu]
   [ui.components.icon.view :as icon]))

(defn view
  [{:keys [label expanded? on-collapse! on-expand! extra-tool opts]} & content]
  [:div
   {:class (uu/cm "mb-0 flex flex-col font-semibold text-sm rounded border border-solid border-base-light-border-paler rounded")}
   [:div
    {:class    "py-1 px-2 flex justify-between items-center cursor-pointer"
     :on-click (fn [_]
                 (if expanded?
                   (on-collapse!)
                   (on-expand!)))}
    [:div
     {:class "flex-1"}
     label]
    [:div
     {:class "flex justify-end items-center flex-auto gap-1 "}
     extra-tool
     [icon/clickable
      {:style-props {:border-color "transparent"}}
      (if expanded?
        [:i.fal.fa-chevron-up]
        [:i.fal.fa-chevron-down])]]]
   (into
    [:div
     {:class (uu/cm "hidden" (when expanded? "block px-2 pb-2"))}]
    content)])
